import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronUp } from "lucide-react";

const TaskSelection = ({ tasks, selectedTask, onTaskSelect }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const visibleTasks = tasks.slice(0, 4);
  const hiddenTasks = tasks.slice(4);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {visibleTasks.map((task) => (
          <button
            key={task.id}
            className={`p-3 rounded-md text-sm font-medium transition duration-300 ease-in-out ${
              selectedTask === task.id
                ? "bg-blue-500 text-white shadow-md"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
            onClick={() => onTaskSelect(task.id)}
          >
            {t(`promptGenerator.tasks.${task.id}`)}
          </button>
        ))}
      </div>
      {hiddenTasks.length > 0 && (
        <div className="mt-4">
          <button
            onClick={toggleExpand}
            className="flex items-center justify-center w-full p-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition duration-300 ease-in-out"
          >
            {isExpanded ? (
              <>
                <ChevronUp className="w-4 h-4 mr-2" />
              </>
            ) : (
              <>
                <ChevronDown className="w-4 h-4 mr-2" />
              </>
            )}
          </button>
          {isExpanded && (
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2 mt-3">
              {hiddenTasks.map((task) => (
                <button
                  key={task.id}
                  className={`p-2 rounded-md text-xs font-medium transition duration-300 ease-in-out ${
                    selectedTask === task.id
                      ? "bg-blue-500 text-white shadow-md"
                      : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
                  onClick={() => onTaskSelect(task.id)}
                >
                  {t(`promptGenerator.tasks.${task.id}`)}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TaskSelection;
